/*
 * @fileOverView Cookie Dialog component definition
 */

import Vue from 'vue';

/**
 * Cookie Dialog Vue
 * @type {class}
 */
Vue.component('cookie-dialog-vue', {
  data: function() {
    return {
      consentStatus: true
    }
  },

  mounted() {
    if (!localStorage.getItem('cookiePolicy')) {
      this.consentStatus = false;
    }
  },

  methods: {
    /**
     * Saves info to local storage so it only appears if it hasn't been acknowledged.
     *
     * @method saveToLocalStorage
     * @public
     */
    saveToLocalStorage() {
      const userConsent = {"status": "true", "date": new Date() }

      localStorage.setItem('cookiePolicy', JSON.stringify(userConsent));
      this.consentStatus = true;
    }
  }
});
